import type { SelectOption } from '@/components/SearchableSelect'
import { pickOldestNonCompleteMonth, reportMonthsRange } from '@/utils/allocationFormat'
import { monthFromIsoDate, reportMonthLabel } from './distribution-waterfall/waterfallJeStatus'

export { pickOldestNonCompleteMonth }

export const PREF_EQUITY_MONTH_RANGE_START = '2025-04'

export function mergePrefEquityMonthSelectOptions(
  postedTxnDates: string[],
  asOf?: Date,
): SelectOption[] {
  const postedMonths = new Set(postedTxnDates.map(monthFromIsoDate))

  return reportMonthsRange(PREF_EQUITY_MONTH_RANGE_START, asOf).map((reportMonth) => ({
    id: reportMonth,
    label: reportMonthLabel(reportMonth),
    status: postedMonths.has(reportMonth) ? 'complete' : 'incomplete',
  }))
}
